import React, { useEffect, useRef } from 'react';
import './CircleAnimation.css';

const CircleAnimation = () => {
  const containerRef = useRef(null);
  const animationFrameRef = useRef(null);

  useEffect(() => {
    const container = containerRef.current;
    if (!container) return;

    // Create canvas - 20% größer
    const canvas = document.createElement('canvas');
    canvas.width = 691;
    canvas.height = 691;
    canvas.style.position = 'absolute';
    canvas.style.left = '0';
    canvas.style.top = '0';
    container.appendChild(canvas);

    const ctx = canvas.getContext('2d');
    const centerX = canvas.width / 2;
    const centerY = canvas.height / 2;
    let time = 0;
    let lastTime = 0;

    // Create dots in concentric rings - 20% größer
    const dotRings = [
      { radius: 58, count: 12 },
      { radius: 115, count: 24 },
      { radius: 173, count: 36 },
      { radius: 230, count: 48 },
      { radius: 288, count: 60 }
    ];

    function animate(timestamp) {
      if (!lastTime) lastTime = timestamp;
      const deltaTime = timestamp - lastTime;
      lastTime = timestamp;
      time += deltaTime * 0.001;

      ctx.clearRect(0, 0, canvas.width, canvas.height);

      // Draw center - 30% größer
      ctx.beginPath();
      ctx.arc(centerX, centerY, 2.6, 0, Math.PI * 2);
      ctx.fillStyle = 'rgba(255, 255, 255, 0.9)';
      ctx.fill();

      // Draw dots in concentric circles with wave effect
      dotRings.forEach((ring, ringIndex) => {
        for (let i = 0; i < ring.count; i++) {
          const angle = (i / ring.count) * Math.PI * 2;
          // Calculate position with pulsing radius - 20% größer
          const radiusPulse = Math.sin(time * 2 - ringIndex * 0.4) * 11.5;
          const x = centerX + Math.cos(angle) * (ring.radius + radiusPulse);
          const y = centerY + Math.sin(angle) * (ring.radius + radiusPulse);
          // Calculate opacity with wave effect
          const opacityWave = 0.4 + Math.sin(time * 2 - ringIndex * 0.4 + i * 0.2) * 0.6;
          // Draw dot - 30% größer
          ctx.beginPath();
          ctx.arc(x, y, 2.6, 0, Math.PI * 2);
          ctx.fillStyle = `rgba(255, 255, 255, ${opacityWave})`;
          ctx.fill();
        }
      });

      animationFrameRef.current = requestAnimationFrame(animate);
    }

    animationFrameRef.current = requestAnimationFrame(animate);

    // Cleanup
    return () => {
      if (animationFrameRef.current) {
        cancelAnimationFrame(animationFrameRef.current);
      }
      if (container && canvas && container.contains(canvas)) {
        container.removeChild(canvas);
      }
    };
  }, []);

  return (
    <div className="circle-animation-wrapper">
      <div className="circle-animation-container">
        <div className="circle-container" ref={containerRef}></div>
      </div>
    </div>
  );
};

export default CircleAnimation;
